export default "66154062e9902d66.ttf"